// export const API_BASE_URL = 'http://localhost:8082/hgnc/api/'

// export const IMAGE_BASE_URL = 'http://localhost:8082/hgnc/'

export const API_BASE_URL = 'http://tyzx.hgnu.edu.cn/api/'

export const IMAGE_BASE_URL = 'http://tyzx.hgnu.edu.cn/'



// WEBPACK FOOTER //
// ./src/config/pathConfig.js